import * as headerTabActions from "./headerSlice";
import * as entrySummaryActions from "./entrySummarySlice";
import * as entryLineDetailActions from "./entryLineDetailSlice";

const actions = {
    ...headerTabActions,
    ...entrySummaryActions,
    ...entryLineDetailActions
}

export default actions;